import type { Template } from "@/types";

export const PO_07_H1_V6: Template[] = [
    {
        id: "po-07-h1v6-01",
        name: "PO 01 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_01.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 67, y: 221, width: 522, height: 378, rotation: 0, imageRotation: 0 },
            { id: "2", x: 736, y: 132, width: 160, height: 274, rotation: 0, imageRotation: 0 },
            { id: "3", x: 736, y: 414, width: 160, height: 274, rotation: 0, imageRotation: 0 },
            { id: "4", x: 904, y: 132, width: 160, height: 274, rotation: 0, imageRotation: 0 },
            { id: "5", x: 904, y: 414, width: 160, height: 274, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1072, y: 132, width: 160, height: 274, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1072, y: 414, width: 160, height: 274, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-02",
        name: "PO 02 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_02.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 46, y: 150, width: 559, height: 330, rotation: 0, imageRotation: 0 },
            { id: "2", x: 704, y: 213, width: 275, height: 396, rotation: 0, imageRotation: 0 },
            { id: "3", x: 987, y: 213, width: 274, height: 396, rotation: 0, imageRotation: 0 },
            { id: "4", x: 46, y: 487, width: 134, height: 182, rotation: 0, imageRotation: 0 },
            { id: "5", x: 188, y: 487, width: 134, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 330, y: 487, width: 134, height: 182, rotation: 0, imageRotation: 0 },
            { id: "7", x: 472, y: 487, width: 134, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-03",
        name: "PO 03 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_03.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 119, y: 112, width: 437, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 704, y: 112, width: 406, height: 596, rotation: 0, imageRotation: 0 },
            { id: "3", x: 119, y: 404, width: 215, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 404, width: 214, height: 305, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1118, y: 112, width: 145, height: 194, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1118, y: 314, width: 145, height: 193, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1118, y: 515, width: 145, height: 193, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-04",
        name: "PO 04 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 136, y: 148, width: 174, height: 240, rotation: 0, imageRotation: 0 },
            { id: "2", x: 317, y: 148, width: 173, height: 240, rotation: 0, imageRotation: 0 },
            { id: "3", x: 136, y: 395, width: 174, height: 240, rotation: 0, imageRotation: 0 },
            { id: "4", x: 317, y: 395, width: 173, height: 240, rotation: 0, imageRotation: 0 },
            { id: "5", x: 668, y: 148, width: 282, height: 487, rotation: 0, imageRotation: 0 },
            { id: "6", x: 957, y: 148, width: 250, height: 158, rotation: 0, imageRotation: 0 },
            { id: "7", x: 957, y: 313, width: 250, height: 322, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-05",
        name: "PO 05 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_05.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 47, y: 231, width: 561, height: 356, rotation: 0, imageRotation: 0 },
            { id: "2", x: 735, y: 80, width: 161, height: 215, rotation: 0, imageRotation: 0 },
            { id: "3", x: 735, y: 303, width: 161, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 735, y: 525, width: 161, height: 214, rotation: 0, imageRotation: 0 },
            { id: "5", x: 904, y: 80, width: 160, height: 215, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1072, y: 80, width: 160, height: 215, rotation: 0, imageRotation: 0 },
            { id: "7", x: 904, y: 303, width: 328, height: 436, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-06",
        name: "PO 06 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_06.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 50, y: 112, width: 555, height: 338, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 50, y: 458, width: 180, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 238, y: 458, width: 180, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 426, y: 458, width: 179, height: 250, rotation: 0, imageRotation: 0 },
            { id: "5", x: 704, y: 139, width: 370, height: 515, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1082, y: 139, width: 181, height: 254, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1082, y: 401, width: 181, height: 253, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-07",
        name: "PO 07 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_07.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 127, y: 48, width: 259, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 127, y: 414, width: 259, height: 358, rotation: 0, imageRotation: 0 },
            { id: "3", x: 394, y: 48, width: 259, height: 358, rotation: 0, imageRotation: 0 },
            { id: "4", x: 661, y: 48, width: 258, height: 358, rotation: 0, imageRotation: 0 },
            { id: "5", x: 927, y: 48, width: 258, height: 358, rotation: 0, imageRotation: 0 },
            { id: "6", x: 927, y: 414, width: 258, height: 358, rotation: 0, imageRotation: 0 },
            { id: "7", x: 394, y: 414, width: 525, height: 358, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-08",
        name: "PO 08 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_08.png",
        size: [1252, 783],
        style: {},
        slots: [         
            { id: "1", x: 0, y: 152, width: 159, height: 236, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 395, width: 159, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 167, y: 152, width: 159, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 167, y: 395, width: 159, height: 236, rotation: 0, imageRotation: 0 },
            { id: "5", x: 334, y: 152, width: 159, height: 236, rotation: 0, imageRotation: 0 },
            { id: "6", x: 334, y: 395, width: 159, height: 236, rotation: 0, imageRotation: 0 },
            { id: "7", x: 501, y: 152, width: 752, height: 479, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-09",
        name: "PO 09 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 576, height: 783, rotation: 0, imageRotation: 0 },
            { id: "2", x: 684, y: 165, width: 509, height: 311, rotation: 0, imageRotation: 0 },
            { id: "3", x: 684, y: 483, width: 97, height: 135, rotation: 0, imageRotation: 0 },
            { id: "4", x: 788, y: 483, width: 97, height: 135, rotation: 0, imageRotation: 0 },
            { id: "5", x: 892, y: 483, width: 96, height: 135, rotation: 0, imageRotation: 0 },
            { id: "6", x: 995, y: 483, width: 96, height: 135, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1098, y: 483, width: 96, height: 135, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-10",
        name: "PO 10 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_10.png",
        size: [1252, 783],
        style: {},
        slots: [         
            { id: "1", x: 57, y: 113, width: 139, height: 193, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 314, width: 139, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 57, y: 515, width: 139, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 203, y: 113, width: 903, height: 594, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1113, y: 113, width: 141, height: 193, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1113, y: 314, width: 141, height: 193, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1113, y: 515, width: 141, height: 192, rotation: 0, imageRotation: 0 }
        ],
    }
];